//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from 'd3';
import { gray, blue, green, orange, other, deleteECRReportImage, exportECRChart, filterECRHeading_AndComparison, compareMeasure, createStackedChart_NoComparison, createStackedChart_Comparison } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';


const AuthorshipChart = ({
    authorData,
    authorData_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#AuthorshipChart svg").remove();
        d3.select("#AuthorshipChart .ecr_tooltip").remove();
        deleteECRReportImage("authorship-chart.png", currentDateTime, report_display_id, vintage);

        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

        if ((compare_measure == 0 && authorData && authorData.length > 0) ||
            (compare_measure > 0 && authorData && authorData_2 && authorData.length > 0 && authorData_2.length > 0)) {
            const subgroups = ["Last Author", "First Author", "Other Publ", "No Publ"]
            const colors = [green, blue, orange, gray]
            //is compare on
            if (compare_measure == 0) {
                createStackedChart_NoComparison(
                    "#AuthorshipChart",
                    parentWidth,
                    authorData,
                    subgroups,
                    "pubStatus",
                    "pct",
                    "Percentage of researchers with types of publications",
                    colors
                );
            }
            else {
                if (authorData_2 && authorData_2.length > 0) {
                    createStackedChart_Comparison(
                        "#AuthorshipChart",
                        parentWidth,
                        authorData,
                        authorData_2,
                        compare_measure,
                        subgroups,
                        "pubStatus",
                        "pct",
                        "Percentage of researchers with types of publications",
                        colors
                    );
                }
            }
            exportECRChart("#AuthorshipChart", "authorship-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }
    }, [authorData, authorData_2, parentWidth])
    //console.log(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

    if (compare_measure > 0) {
        //need both authorData and authorData_2 to have at least one value per year

        const years = ['1', '2', '3', '4', '5', '6', '7', '8'];
        const filtered1 = authorData?.filter(function (item) {
            return years.includes(item.t_emp);
        })
        const filtered2 = authorData_2?.filter(function (item) {
            return years.includes(item.t_emp);
        })

        //console.log(filtered1)
        //console.log(filtered2)
    }

    return (
        <div className="ChartComponent">
            <div id="AuthorshipChart_ForExport">
                <Heading3 bold italic>Authorship, {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                <div id="AuthorshipChart"></div>
                {(authorData?.length == 0 || (compare_measure > 0 && (authorData?.length == 0 || authorData_2?.length == 0))) && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This chart shows the percentage of faculty members on sponsored projects listed as first or last author on at least one publication during this data year. "Data Year" refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from {start_year} to {end_year} were used to build these cohorts.
                </ReportText>
                {/*(compare_measure > 0) &&
                    (filtered1?.length < 8 || filtered2?.length < 8) &&
                    <p>Note: Insufficient data</p>
                */}
            </div>
            <a className="export" onClick={() => exportECRChart("#AuthorshipChart_ForExport", "authorship-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default AuthorshipChart;